import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import "../../DealApproval.scss";

const TextForm = ({ blockItems, itemIndex, blockItem, onUpdateBlockItem, onDeleteBlockItem }) => {
    return (
        <>
            <div className="metric-header-row">
                <label>Text Area {itemIndex + 1}</label>
                <button
                    type="button"
                    className="block-delete-btn-inline"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    <DeleteOutlined />
                </button>
            </div>
            <textarea
                rows={3}
                placeholder="Enter your section paragraph..."
                value={blockItem.text || ""}
                maxLength={500}
                onChange={(e) => onUpdateBlockItem(itemIndex, "text", e.target.value)}
            />
            <span className="char-counter-text">{(blockItem.text || "").length}/500</span>
            {(blockItem.text || "").length >= 500 && <p className="char-limit-note">Max 500 characters reached</p>}
        </>
    );
};

export default TextForm;
